import { PERMISSION } from '@/constants/permission.constant';

const invoiceList = () => import('@/views/invoices/InvoiceList.vue');
const addPayment = () => import('@/views/invoices/forms/CreatePayment.vue');

const paymentList = () => import('@/views/invoices/PaymentList.vue');
const pagePayment = () => import('@/components/partials/MenuLinkView.vue');
export const invoicesRoute = [
  {
    path: '/payment',
    name: 'payment',
    component: pagePayment,
    meta: { requiresAuth: true, permissions: [PERMISSION.INVOICE_READ] },
  },
  {
    path: '/payment/invoices',
    name: 'invoice-list',
    component: invoiceList,
    meta: { requiresAuth: true, permissions: [PERMISSION.INVOICE_READ] },
  },

  {
    path: '/payment/payment-list',
    name: 'payment-list',
    component: paymentList,
    meta: { requiresAuth: true, permissions: [PERMISSION.PAYMENT_READ] },
  },

  {
    path: '/payment/invoices/add-payment',
    name: 'add-payment',
    component: addPayment,
    meta: { requiresAuth: true, permissions: [PERMISSION.PAYMENT_CREATE] },
  },
];
